import type { Tokens, TokenizerExtension } from "marked";

let regex = /<(?<type>[@#&])(?<id>\d+)>/;
let rule = new RegExp(`^${regex.source}`);

export type MentionToken = Tokens.Generic & {
  id: BigInt;
  mentionType: "user" | "channel" | "role";
};

export const mentionTokenizer: TokenizerExtension = {
  name: "mention",
  level: "inline",
  start(src: string): number | undefined {
    return src.match(regex)?.index;
  },
  tokenizer(src: string): MentionToken | undefined {
    let match = rule.exec(src);
    if (!match?.groups?.id || !match?.groups?.type) return;

    let mentionType = {
      "@": "user",
      "#": "channel",
      "&": "role",
    }[match.groups.type] as "user" | "channel" | "role";

    return {
      type: "mention",
      raw: match[0],
      id: BigInt(match.groups.id),
      mentionType,
    };
  }
}
